/**
 * Return formattedDate string (eg. "7 Sep 2022, 2:13 PM").
 *
 * @param {dateString} The date string (eg. "2022-09-07T07:13:47.355Z")
 */
export function formatDate(dateString) {
    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    const date = new Date(dateString).getDate();
    const month = months[new Date(dateString).getMonth()];
    const year = new Date(dateString).getFullYear();
    const time = new Date(dateString).toLocaleTimeString();
    const formattedTime = time.slice(0, 4) + time.slice(7);
    const formattedDate = `${date} ${month} ${year}, ${formattedTime}`;
    return formattedDate;
}
/**
 * Return formattedTime(mm:ss) string (eg. "00:02:00").
 *
 * @param {time} The time number (eg. "371.923338")
 */
export function getFormattedTime(time) {
    if (time === undefined)
        return;
    const h = Math.floor(time / 3600);
    const hour = h >= 10 ? h : '0' + h;
    const m = Math.floor(time / 60);
    const min = m >= 10 ? m : '0' + m;
    const s = Math.floor(time % 60);
    const sec = s >= 10 ? s : '0' + s;
    return hour + ':' + min + ':' + sec;
}
export function getDiffBetweenDates(dateInitial, dateFinal) {
    const h = Math.floor((dateFinal - dateInitial) / (1000 * 3600));
    const hour = h >= 10 ? h : '0' + h;
    const m = Math.floor((dateFinal - dateInitial) / (1000 * 60));
    const min = m >= 10 ? m : '0' + m;
    const s = Math.floor(((dateFinal - dateInitial) / 1000) % 60);
    const sec = s >= 10 ? s : '0' + s;
    return hour + ':' + min + ':' + sec;
}
//# sourceMappingURL=datetime.js.map